(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ol-blog-hub"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initialize(root) {
    root.querySelectorAll('[data-ol-hub]').forEach(function (hub) {
      if (hub.dataset.searchReady) return;
      const field = hub.querySelector('.ol-hub__feld');
      const form = hub.querySelector('.ol-hub__suche');
      const index = hub.querySelector('[data-hub-index]');
      const filters = hub.querySelector('[data-hub-filters]');
      const items = Array.from(hub.querySelectorAll('[data-hub-article]'));
      if (!field || !form || !index || !filters || !items.length) return;
      hub.dataset.searchReady = '1';
      const count = hub.querySelector('[data-hub-count]');
      const empty = hub.querySelector('[data-hub-empty]');
      const clear = hub.querySelector('[data-hub-clear]');
      const allowed = ['all','windows','office','m365','server'];
      const readLocation = () => {
        const params = new URLSearchParams(location.search);
        category = allowed.includes(params.get('family')) ? params.get('family') : 'all';
        field.value = params.get('guide_search') || '';
        filters.querySelectorAll('[data-hub-category]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.hubCategory===category)));
      };
      let category = 'all';
      readLocation();
      let urlTimer;
      function syncLocation() {
        clearTimeout(urlTimer);
        urlTimer = setTimeout(()=>{
          const url = new URL(location.href);
          if(category==='all')url.searchParams.delete('family');else url.searchParams.set('family',category);
          if(field.value.trim())url.searchParams.set('guide_search',field.value.trim());else url.searchParams.delete('guide_search');
          history.replaceState(null,'',url);
        },200);
      }
      function normal(text) { return text.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/[-_]/g,' '); }
      const entries = items.map(item => ({item, text:normal(item.dataset.search)}));
      function filter() {
        const words = normal(field.value).trim().split(/\s+/).filter(Boolean);
        let total = 0;
        entries.forEach(({item,text}) => {
          const matches = category === 'all' || item.dataset.category === category || (category === 'windows' && item.dataset.category === 'server') || (category === 'office' && item.dataset.category === 'm365');
          const visible = matches && words.every(word => text.includes(word));
          item.hidden = !visible;
          if (visible) total++;
        });
        count.textContent = count.dataset.count.replace('{n}',String(total));
        empty.hidden = total !== 0;
        clear.disabled = !field.value && category === 'all';
        syncLocation();
      }
      filters.hidden = false;
      count.hidden = false;
      field.setAttribute('aria-controls', hub.querySelector('.ol-hub__liste').id);
      filters.querySelectorAll('[data-hub-category]').forEach(button => {
        button.hidden = button.dataset.hubCategory !== 'all' && !items.some(item => item.dataset.category === button.dataset.hubCategory);
        button.addEventListener('click', function () {
          category = button.dataset.hubCategory;
          filters.querySelectorAll('[data-hub-category]').forEach(el => el.setAttribute('aria-pressed',String(el === button)));
          filter();
        });
      });
      hub.querySelectorAll('[data-hub-book]').forEach(book => {
        book.addEventListener('click',function(event) {
          event.preventDefault();
          field.value = '';
          category = book.dataset.hubBook;
          filters.querySelectorAll('[data-hub-category]').forEach(button => button.setAttribute('aria-pressed',String(button.dataset.hubCategory === category)));
          filter();
          index.setAttribute('tabindex','-1');
          index.focus({preventScroll:true});
          index.scrollIntoView({block:'start',behavior:window.matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});
        });
      });
      field.addEventListener('input',filter);
      field.addEventListener('search',filter);
      clear.addEventListener('click', function () {
        field.value = ''; category = 'all';
        filters.querySelectorAll('[data-hub-category]').forEach(el => el.setAttribute('aria-pressed',String(el.dataset.hubCategory === 'all')));
        filter(); field.focus({preventScroll:true});
      });
      form.addEventListener('submit', function (event) {
        event.preventDefault(); filter();
        index.setAttribute('tabindex','-1'); index.focus({preventScroll:true});
        index.scrollIntoView({block:'start',behavior:window.matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});
      });
      filter();
      const restore = () => {readLocation();filter();};
      window.addEventListener('popstate',restore);
      document.addEventListener('shopify:section:unload',event=>{if(event.target.contains(hub)){clearTimeout(urlTimer);window.removeEventListener('popstate',restore);}},{once:true});
    });
  }
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ol-gutschein"]) return;
  try {
    
document.addEventListener('click', async function(event) {
  const button = event.target.closest('[data-gs-code]');
  if (!button || button.dataset.copying) return;
  button.dataset.copying = 'true';
  const code = button.dataset.code;
  const label = button.querySelector('.ol-gs__copylabel');
  const original = label.textContent;
  const status = button.closest('.ol-gs__zeile').querySelector('[data-gs-status]');
  let copied = false;
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(code);
      copied = true;
    }
  } catch (_) {}
  if (!copied) {
    const input = document.createElement('textarea');
    input.value = code;
    input.setAttribute('readonly', '');
    input.style.cssText = 'position:fixed;inset:0 auto auto -9999px;';
    document.body.append(input);
    input.select();
    try { copied = document.execCommand('copy'); } catch (_) {}
    input.remove();
    button.focus({preventScroll:true});
  }
  if (copied) {
    label.textContent = button.dataset.fertig;
    status.textContent = button.dataset.fertig;
    button.classList.add('ist-kopiert');
    setTimeout(function() {
      label.textContent = original;
      status.textContent = '';
      button.classList.remove('ist-kopiert');
      delete button.dataset.copying;
    }, 2200);
  } else {
    const range = document.createRange();
    range.selectNodeContents(button.querySelector('.ol-gs__codewort'));
    const selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);
    delete button.dataset.copying;
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ol24-m365"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initialize(root) {
    root.querySelectorAll('.ol24-m365').forEach(function (section) {
      if (section.dataset.m365Ready) return;
      section.dataset.m365Ready = 'true';
      const table = section.querySelector('.ol-vgl__tabelle');
      const switcher = section.querySelector('[data-ol24-umschalter]');
      function selectColumn(column) {
        if (!['1','2','3'].includes(column)) return;
        section.classList.add('has-selection');
        section.querySelectorAll('.ol-vgl__karte').forEach(function(card) {
          card.classList.toggle('ist-gewaehlt', card.dataset.spalte === column);
        });
        section.querySelectorAll('.ol24-m365__wahlknopf,[data-spalte-wahl]').forEach(function(button) {
          const selected = (button.dataset.ziel || button.dataset.spalteWahl) === column;
          button.classList.toggle('ist-aktiv', selected);
          button.setAttribute('aria-pressed', String(selected));
        });
        section.querySelectorAll('.ol-vgl__zelle[data-spalte]').forEach(function(cell) {
          cell.classList.toggle('ist-markiert', cell.dataset.spalte === column);
        });
        if (table) table.dataset.aktiv = column;
      }
      section.addEventListener('click', function(event) {
        const button = event.target.closest('.ol24-m365__wahlknopf,[data-spalte-wahl]');
        if (!button || !section.contains(button)) return;
        const column = button.dataset.ziel || button.dataset.spalteWahl;
        selectColumn(column);
        if (button.dataset.ziel && window.matchMedia('(max-width: 989px)').matches) {
          const card = section.querySelector('.ol-vgl__karte[data-spalte="' + column + '"]');
          if (card) {
            card.focus({preventScroll:true});
            card.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',block:'center'});
          }
        }
      });
      function restoreHash() {
        const card = Array.from(section.querySelectorAll('.ol-vgl__karte')).find(el => '#' + el.id === location.hash);
        if (card) selectColumn(card.dataset.spalte);
      }
      restoreHash();
      window.addEventListener('hashchange', restoreHash);
      if (switcher) switcher.hidden = false;
    });
  }
  initialize(document);
  document.addEventListener('shopify:section:load', function(event) { initialize(event.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
